import * as React from 'react';
import { Checkbox } from '@highereducation/hen-ui';
import { fieldName } from '../submit';
import {
  FieldLegend,
  FieldErrorMessage,
  type FieldComponentProps,
} from './parts';

/** CONSENT field — description panel + single required hen-ui `Checkbox`. */
export function ConsentField({ field, formId, error }: FieldComponentProps) {
  const name = fieldName(formId, field.id);
  // Consent copy is CMS-authored HTML that is sanitized server-side in the
  // shortcode's getEnrichedData step, so here we only convert newlines to
  // <br /> before injecting the already-safe markup.
  const description = field.description
    ? field.description.replace(/\n/g, '<br />')
    : null;

  return (
    <>
      <fieldset className='border-0 p-0'>
        <FieldLegend field={field} />
        {description && (
          <div
            className='mb-sm mt-xxs max-h-[15rem] w-full overflow-y-auto border border-neutral-200 bg-white p-xs text-b5 leading-6 text-body'
            dangerouslySetInnerHTML={{ __html: description }}
          />
        )}
        <Checkbox
          id={name}
          name={name}
          required={Boolean(field.isRequired)}
          error={Boolean(error)}
          label={field.checkboxLabel ?? ''}
        />
      </fieldset>
      <FieldErrorMessage error={error} />
    </>
  );
}
